<template>
  <div
    v-bind:class="{
      'demo__flex demo__flex-middle': mode === 'horizontal',
    }"
  >
    <div v-if="!isFullNameEmpty">
      <div
        v-bind:class="{
          ['demo__font--' + css.author.font.size]: true,
          ['demo__weight--' + css.author.font.weight]: true,
        }"
      >
        {{ fullname }}
      </div>
      <div
        v-bind:class="{
          ['demo__font--' + css.company.font.size]: true,
          ['demo__weight--' + css.company.font.weight]: true,
        }"
        v-if="author.company"
      >
        {{ author.company }}
      </div>
    </div>
    <div
      v-else-if="css.author"
      v-bind:class="{
        ['demo__font--' + css.author.font.size]: true,
        ['demo__weight--' + css.author.font.weight]: true,
      }"
    >
      {{ $t("As Anon") }}
    </div>
    <div
      class=""
      v-bind:class="{
        'demo__margin-top--30': mode === 'vertical',
        'demo__flex-right': mode === 'horizontal',
        'demo__flex demo__flex-middle': !isMobile,
      }"
    >
      <div class="demo__flex demo__flex-middle">
        <AuthLockBlock
          v-for="(reaction, index) in reactions"
          :key="reaction.title"
          :ym_location="reaction.ymLocation"
          v-bind:class="{
            ['demo__margin-left--' + css.reactions.margin]: index !== 0,
          }"
        >
          <div class="demo__flex demo__flex-middle" @click="reaction.click()">
            <i
              v-bind:class="{
                ['demo__font--' + css.reactions.icon.size]: true,
                ['demo__margin-right--' + css.reactions.icon.margin]: true,
                [reaction.icon]: true,
                'animated bounceIn': reaction.animate,
              }"
            ></i>
            <div
              v-bind:class="{
                ['demo__font--' + css.reactions.text.size]: true,
                ['demo__weight--' + css.reactions.text.weight]: true,
              }"
            >
              {{ object[reaction.field] }}
            </div>
          </div>
        </AuthLockBlock>
      </div>
      <div
        class="demo__flex-right"
        v-if="buttons && buttons.length"
        v-bind:class="{
          'demo__flex demo__flex-column demo__margin-top--20 111': isMobile,
        }"
      >
        <a-tooltip
          :visible="button.showTippy"
          placement="bottom"
          v-for="(button, index) in buttons"
          :key="button.title"
        >
          <div class="p-all share-tooltip" slot="title">
            {{ $t(button.tippy) }}
          </div>

          <a-button
            v-bind:style="{
              width: isMobile
                ? '100% !important'
                : button.width
                ? button.width + 'px !important'
                : 'auto',
              marginTop: isMobile ? '10px' : 'unset',
            }"
            v-bind:class="{
              'demo__margin-right--20': index !== buttons.length - 1,
              ['demo__button--' + button.bg]: true,
            }"
            class="demo__button"
            @click="button.callback ? button.callback() : false"
          >
            <i
              class="demo__margin-right--9"
              v-bind:class="{
                [button.icon]: true,
              }"
            ></i>
            {{ button.title }}
          </a-button>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    object: {
      type: Object,
      required: true,
    },
    author: {
      type: Object,
      required: false,
      default: () => null,
    },
    reactions: {
      type: Array,
      required: true,
    },
    buttons: {
      type: Array,
      required: false,
      default: () => [],
    },
    css: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: false,
    },
  },
  computed: {
    fullname() {
      return this.getAuthorFullName();
    },
    isFullNameEmpty() {
      return this.fullname.replaceAll(" ", "").length === 0;
    },
    ...mapGetters(["isMobile", "user"]),
  },
  created() {
    this.$accessModule("bottom_reactions", this);
  },
  methods: {
    getAuthorFullName() {
      const fields = ["last_name", "first_name", "middle_name"];
      if (
        !this.author ||
        !fields.filter((field) => this.author[field]).length
      ) {
        return "";
      }
      return fields
        .map((field, index) => {
          return (
            (this.author.initials && index !== 0
              ? (this.author[field] || "").slice(0, 1) + "."
              : this.author[field]) + (index !== fields.length - 1 ? " " : "")
          );
        })
        .toString()
        .replaceAll(",", "");
    },
  },
};
</script>
